// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3fZGJ","header":"ReportDetails_header__1kDw2","title":"ReportDetails_title__1cUbj","left":"ReportDetails_left__3pzqy"};